<script setup lang="ts">
import { ArrowLeft } from '@element-plus/icons-vue'
import { $t } from "@user-center/utils/i18n";
import { useRouter } from 'vue-router'

withDefaults(defineProps<{
  label?: string
}>(), {
  label: $t('actions.back'),
})

const router = useRouter()

function goBack() {
  router.back()
}
</script>

<template>
  <div class="route-back-button">
    <button class="route-back-button__control" type="button" @click="goBack">
      <el-icon><ArrowLeft /></el-icon>
      <span>{{ label }}</span>
    </button>
  </div>
</template>

<style scoped>
.route-back-button {
  align-items: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.03);
  display: inline-flex;
  justify-content: flex-start;
  padding: 14px 20px;
  width: fit-content;
}

.route-back-button__control {
  align-items: center;
  background: transparent;
  border: none;
  color: #1d1b1a;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 16px;
  font-weight: 500;
  gap: 8px;
  line-height: 24px;
  padding: 0;
}

.route-back-button__control .el-icon {
  font-size: 18px;
}

.route-back-button__control:hover {
  color: #ff7228;
}
</style>
